<div class="container p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Cadastro de Produto</h1>

  <form #produtoForm="ngForm" name="produtoForm" class="space-y-4">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <!-- Linha 1 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <label for="nome" class="mb-1 font-medium text-gray-700">Nome</label>
        <input pInputText id="nome" type="text" placeholder="Nome" [(ngModel)]="produto.nome" name="nome" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="preco-compra" class="mb-1 font-medium text-gray-700">Preço de compra</label>
        <p-inputNumber id="preco-compra" [(ngModel)]="produto.precoCompra" name="preco-compra" placeholder="Digite o preço de compra" mode="currency" currency="BRL" class="w-full"></p-inputNumber>
      </div>
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="preco" class="mb-1 font-medium text-gray-700">Preço de varejo</label>
        <p-inputNumber id="preco" [(ngModel)]="produto.preco" name="preco" placeholder="Digite o preço" mode="currency" currency="BRL" class="w-full"></p-inputNumber>
      </div>
    </div>

    <!-- Linha 2 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="precoAtacado" class="mb-1 font-medium text-gray-700">Preço de Atacado</label>
        <p-inputNumber id="precoAtacado" [(ngModel)]="produto.precoAtacado" name="precoAtacado" placeholder="Digite o preço de Atacado" mode="currency" currency="BRL" class="w-full"></p-inputNumber>
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="precoFabrica" class="mb-1 font-medium text-gray-700">Preço de Fábrica</label>
        <p-inputNumber id="precoFabrica" [(ngModel)]="produto.precoFabrica" name="precoFabrica" placeholder="Digite o preço de fábrica" mode="currency" currency="BRL" class="w-full"></p-inputNumber>
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="barras" class="mb-1 font-medium text-gray-700">Código de barras</label>
        <input pInputText id="barras" type="text" placeholder="Código de barras" [(ngModel)]="produto.codigoBarras" name="barras" class="w-full p-component rounded border-gray-300" />
      </div>
    </div>

    <!-- Linha 3 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="marca" class="mb-1 font-medium text-gray-700">Marca</label>
        <p-dropdown data-testid="marca-dropdown" [options]="marcas" optionLabel="nome" optionValue="id" [(ngModel)]="selectedMarcaId" name="selectedMarcaId" placeholder="Selecione uma marca" class="w-full"></p-dropdown>
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="fornecedor" class="mb-1 font-medium text-gray-700">Fornecedor</label>
        <p-dropdown data-testid="fornecedor-dropdown" [options]="fornecedores" optionLabel="nome" optionValue="id" [(ngModel)]="selectedFornecedorId" name="selectedFornecedorId" placeholder="Selecione um fornecedor" class="w-full"></p-dropdown>
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="serial" class="mb-1 font-medium text-gray-700">Código Serial/Imei</label>
        <input pInputText id="serial" type="text" placeholder="Código Serial/Imei" [(ngModel)]="produto.serialImei" name="serial" class="w-full p-component rounded border-gray-300" />
      </div>
    </div>

    <!-- Linha 4 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-4 flex flex-col">
            <label for="garantia" class="mb-1 font-medium text-gray-700">Garantia</label>
            <select id="garantia" [(ngModel)]="produto.garantia" name="garantia" class="w-full h-12 p-component rounded border border-gray-300">
              <option value="" disabled selected>Selecione a garantia</option>
              <option value="N_APLICAVEL">N/A</option>
              <option value="SEM_GARANTIA">Sem garantia</option>
              <option value="SETE_DIAS">7 dias de garantia</option>
              <option value="TRINTA_DIAS">30 dias de garantia</option>
              <option value="NOVENTA_DIAS">90 dias de garantia</option>
              <option value="SEIS_MESES">6 meses de garantia</option>
              <option value="UM_ANO">1 ano de garantia</option>
              <option value="UM_ANO_APPLE">1 ano de garantia Apple</option>
              <option value="GARANTIA_APPLE">Garantia Apple</option>
            </select>
        </div>
    </div>

    <div class="flex space-x-4 pt-4">
      <div class="button-group">
        <button *ngIf="!editMode" pButton type="button" class="btn btn-primary btn-md" (click)="cadastrar()">
          <i class="pi pi-check mr-2"></i>
          <span>Cadastrar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-primary btn-md" (click)="salvarAlteracao()">
          <i class="pi pi-save mr-2"></i>
          <span>Salvar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-secondary btn-md" (click)="cancelarEdicao()">
          <i class="pi pi-times mr-2"></i>
          <span>Cancelar</span>
        </button>
      </div>
    </div>
  </form>

  <div class="overflow-x-auto">
    <p-table [value]="produtos" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Nome</th>
          <th class="p-2 border-b text-left">Situação</th>
          <th class="p-2 border-b text-left">Preço</th>
          <th class="p-2 border-b text-left">Marca</th>
          <th class="p-2 border-b text-left">Fornecedor</th>
          <th class="p-2 border-b text-left">Estoque</th>
          <th class="p-2 border-b text-left">Serial/Imei</th>
          <th class="p-2 border-b text-left">Garantia</th>
          <th class="p-2 border-b text-left">Data Cadastro</th>
          <th class="p-2 border-b text-left">Data Última Modificação</th>
          <th class="p-2 border-b text-left">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-produto>
        <tr>
          <td class="p-2 border-b">{{ produto.id }}</td>
          <td class="p-2 border-b">{{ produto.nome }}</td>
          <td class="p-2 border-b">
            <ng-container *ngIf="produto.ativo !== false; else notActive">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Ativo</span>
            </ng-container>
            <ng-template #notActive>
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">Desativado</span>
            </ng-template>
          </td>
          <td class="p-2 border-b">{{ produto.preco | currency:'BRL' }}</td>
          <td class="p-2 border-b">{{ produto.marca?.nome }}</td>
          <td class="p-2 border-b">{{ produto.fornecedor?.nome }}</td>
          <td class="p-2 border-b">{{ produto.estoque?.qtdDisponivel }}</td>
          <td class="p-2 border-b">{{ produto.serialImei || "-"}}</td>
          <td class="p-2 border-b">{{ getGarantiaLabel(produto.garantia) }}</td>
          <td class="p-2 border-b">{{ produto.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">{{ produto.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">
            <div class="flex items-center space-x-1">
              <button pButton type="button" class="p-button-text p-button-sm text-gray-700" title="Editar produto" (click)="editar(produto)">
                <i class="pi pi-pencil"></i>
              </button>
              <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="produto.ativo ? 'text-red-600' : 'text-green-600'" [title]="produto.ativo ? 'Desativar produto' : 'Ativar produto'" (click)="confirmarAtivarDesativar(produto)">
                <i [ngClass]="produto.ativo ? 'pi pi-ban text-red-600' : 'pi pi-user-plus text-green-600'"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
